import { styled } from '@mui/material';

const DataGridWrapper = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.N80.main,
}));
const DataGridInnerWrapper = styled('div')(({ theme }) => ({
    display: 'grid',
    gridGap: 16,
    backgroundColor: theme.palette.N70.main,
    padding: 20,
}));
const DataGridTable = styled('table')({
    gridRow: 2,
    gridColumn: '1/3',
    borderCollapse: 'collapse',
    width: '100%',
});
const DataGridTitle = styled('div')(({ theme }) => (Object.assign({ gridRow: 1, gridColumn: 1, display: 'inline-flex', alignItems: 'center', gap: 16, color: theme.palette.N20.main }, theme.typography.h2)));
const TopButtonsContainer = styled('div')({
    gridRow: 1,
    gridColumn: 2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
    gap: 8,
});
const ActionButtonsContainer = styled('div')({
    gridRow: 3,
    gridColumn: '1 / 2',
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
});
const ActionableTableRow = styled('tr')({ cursor: 'pointer' });
const StyledTableCell = styled('td')(({ theme, width, isHighlighted, isDisabled }) => ({
    height: 40,
    width,
    paddingLeft: 10,
    paddingRight: 10,
    verticalAlign: 'middle',
    backgroundColor: isHighlighted ? theme.palette.N60.main : theme.palette.N80.main,
    color: isDisabled ? theme.palette.N30.main : theme.palette.N10.main,
}));
const ExpansionCell = styled('td')(({ theme, isDisabled }) => ({
    padding: 10,
    backgroundColor: theme.palette.N95.main,
    opacity: isDisabled ? '50%' : 'initial',
}));
const StyledFirstCell = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'fit-content(0) auto fit-content(0)',
});
const StyledCellContent = styled('div')({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    gridColumn: 2,
});
const ErrorIconContainer = styled('div')({ height: 16, width: 16, marginRight: 4 });

export { ActionButtonsContainer, ActionableTableRow, DataGridInnerWrapper, DataGridTable, DataGridTitle, DataGridWrapper, ErrorIconContainer, ExpansionCell, StyledCellContent, StyledFirstCell, StyledTableCell, TopButtonsContainer };
//# sourceMappingURL=styled.js.map
